module.exports = __webpack_public_path__ + "static/img/person1_img.02cbb2c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stageImg/person1_img.png
// module id = hq45
// module chunks = 1